import React, { useMemo } from 'react';
import { Button } from '@this/shared/ui/inputs/button';
import type User from '@this/domain/user/user';
import MainTitle from './main_title';

interface Props {
  user: User | null | undefined;
}

const GracePeriodExpired: React.FC<Props> = ({ user }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <MainTitle value="ご利用に関するお知らせ" />
        <div style={styles.card}>
          <p>いつも当サービスをご利用いただき、ありがとうございます。</p>
          <p>お客様のアカウントの無料期間が終了いたしました。</p>
          <p style={styles.message}>継続してサービスをご利用いただくには、</p>
          <p>管理者権限を持つアカウントで決済情報のご登録をお願いいたします。</p>
          {user?.isOrganizationAdmin && (
            <Button href="/aiexpense/organization/plans" isExternal style={styles.registerButton}>
              決済情報を登録
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const getStyles = () => ({
  container: {
    padding: '30px 24px 0'
  },
  inner: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  card: {
    background: 'white',
    borderRadius: '4px',
    padding: '28px 32px',
    marginTop: '12px',
    fontSize: '1.1rem'
  },
  message: {
    marginTop: '16px'
  },
  registerButton: {
    marginTop: '32px',
    fontSize: '1.1rem'
  }
});

export default GracePeriodExpired;
